import { createContext } from 'react';

export default createContext({
  selectedOptions: undefined,
  allOptions: undefined,
  onChange: undefined,
  inputValue: undefined,
  setSelectedOptions: undefined,
  setAllOptions: undefined,
  setInputValue: undefined,
  onEnterClick: undefined,
});
